// extracted by mini-css-extract-plugin
export default {"container":"AppointmentsHistory_container__m+EXr"};